import httpClient from './httpClient';

const employService = {
    searchJobOffer(pos) {
        return httpClient.get(`/api/adv/job/search/${pos.lat}/${pos.lng}/`);
    },
    getJobOffer(id) {
        return httpClient.get(`/api/adv/job/${id}`);
    },
    applyJobOffer(id) {
        return httpClient.post(`/api/adv/job/${id}/application`);
    },
    getMyApplications() {
        return httpClient.get(`/api/adv/job/applications`);
    },
    deleteAnnulerOffre(id) {
        return httpClient.delete(`/api/adv/job/${id}/application`);
    }
}

export default employService;